export const CONSTANTS = {
    API_HOST: process.env.REACT_APP_API_HOST,
    SOCKET_HOST: process.env.REACT_APP_SOCKET_HOST,
    API_URI: process.env.REACT_APP_API_URI,
    REST_API_URI: process.env.REACT_APP_REST_API_URI,
    DOC_API_URI: process.env.REACT_APP_DOC_API_URI,
    PUBLIC_API_URL: process.env.REACT_APP_PUBLIC_API_URL,
    WS_URI: process.env.REACT_APP_WS_URI,
    REACT_APP_URI: process.env.REACT_APP_URI,
    ELASTIC_PROXY_HOST: process.env.REACT_APP_ELASTIC_PROXY_HOST,
    FEATURE_TOGGLE: process.env.REACT_APP_SHOW_TOGGLED_FEATURES === 'true',
    DEPLOY_ENV: process.env.REACT_APP_DEPLOY_ENV || 'local',
    NSHIFT_DEVELOPER_ID: process.env.REACT_APP_NSHIFT_DEVELOPER_ID || '',
    TOKEN_KEY: 'token',
    SOCKET_ID_KEY: 'socketId',
    SOCKET_SESSION: 'socketStr',
    LAB_ID_KEY: 'current-lab-id',
    USER_ID_KEY: 'userId',
    PTJ_ORG_NUM: '556077-2419',
    FORTNOX_AUTH_URL: process.env.REACT_APP_FORTNOX_AUTH_URL,
    // Fortnox has no per-environment env var like Visma; default to this app's own callback route.
    FORTNOX_REDIRECT_URL:
        process.env.REACT_APP_FORTNOX_REDIRECT_URL || `${window.location.origin}/fortnox-auth-callback`,
    FORTNOX_TEMP_STATE_KEY: 'fortnox-temp-state',
    VISMA_AUTH_URL: process.env.REACT_APP_VISMA_AUTH_URL,
    VISMA_REDIRECT_URL: process.env.REACT_APP_VISMA_REDIRECT_URL,
    VISMA_TEMP_STATE_KEY: 'visma-temp-state',
    THREE_SHAPE_AUTH_URL: process.env.REACT_APP_THREE_SHAPE_AUTH_URL,
    THREE_SHAPE_AUTH_REDIRECT: process.env.REACT_APP_THREE_SHAPE_AUTH_REDIRECT,
    DENTHUB_PUBLIC_URL: process.env.REACT_APP_DENTHUB_PUBLIC_APP_URI,
    RELEASE_NAME: process.env.REACT_APP_RELEASE_NAME,
    REACT_APP_RELEASE_ID: process.env.REACT_APP_RELEASE_ID,
    AUTH_FRONTEND_URL: process.env.REACT_APP_AUTH_FRONTEND_URL,
    MEDIT_AUTH_URL: process.env.REACT_APP_MEDIT_AUTH_URL,
    MEDIT_AUTH_REDIRECT: process.env.REACT_APP_MEDIT_AUTH_REDIRECT,
    MEDIT_SCOPE: process.env.REACT_APP_MEDIT_SCOPE,
    MEDIT_STATE: process.env.REACT_APP_MEDIT_STATE,
    DEXIS_AUTH_URL: process.env.REACT_APP_DEXIS_AUTH_URL,
    DEXIS_AUTH_REDIRECT: process.env.REACT_APP_DEXIS_AUTH_REDIRECT,
    PANDA_AUTH_URL: process.env.REACT_APP_PANDA_AUTH_URL,
    PANDA_EU_AUTH_REDIRECT: process.env.REACT_APP_PANDA_EU_AUTH_REDIRECT,
    PANDA_AUTH_REDIRECT: process.env.REACT_APP_PANDA_AUTH_REDIRECT,
    DS_CORE_AUTH_URL: process.env.REACT_APP_DS_CORE_AUTH_URL,
    DS_CORE_AUTH_REDIRECT: process.env.REACT_APP_DS_CORE_AUTH_REDIRECT,
    REACT_APP_MOBILE_UTILS_URL: process.env.REACT_APP_MOBILE_UTILS_URL,
    GOOGLE_PLACES_API_BASE_URL: process.env.REACT_APP_GOOGLE_PLACES_API_BASE_URL,
    GOOGLE_PLACES_API_KEY: process.env.REACT_APP_GOOGLE_PLACES_API_KEY,
    SETTINGS_VALUES: {
        SIMPLE: 'Simple',
        ACTION_BASED: 'Action-based',
    },
    SAMPLE_METHODS: ['PHYSICAL', 'DIGITAL', 'NO_SAMPLE'],
    UPPER_JAW: ['18', '17', '16', '15', '14', '13', '12', '11', '21', '22', '23', '24', '25', '26', '27', '28'],
    LOWER_JAW: ['48', '47', '46', '45', '44', '43', '42', '41', '31', '32', '33', '34', '35', '36', '37', '38'],
    SETTINGS_NAMES: {
        CURRENCY: 'CURRENCY',
        ORDER_VERSION: 'ORDER_VERSION',
        COMPLETED_DRAFT: 'COMPLETED_DRAFT',
        ENABLE_TIOTANDVARD_PRICING: 'ENABLE_TIOTANDVARD_PRICING',
        ENABLE_TIOTANDVARD_PRICING_FOR_LAB: 'ENABLE_TIOTANDVARD_PRICING_FOR_LAB',
        DISALLOW_NON_DENTIST: 'DISALLOW_NON_DENTIST',
        TREATING_CLINICIAN_TITLE_WORDS: 'TREATING_CLINICIAN_TITLE_WORDS',
        RECENT_LAB_LIST: 'RECENT_LAB_LIST',
        ADD_CONNECTED_DENTIST: 'ADD_CONNECTED_DENTIST',
        ADD_USER_WHITELIST_DOMAINS: 'ADD_USER_WHITELIST_DOMAINS',
        EDIT_ACTION_PRICE_LIST: 'EDIT_ACTION_PRICE_LIST',
        DEFAULT_LOGIN_METHOD: 'DEFAULT_LOGIN_METHOD',
        EMAIL_EXT_USER_ASSIGNED_NOTIFICATION: 'EMAIL_EXT_USER_ASSIGNED_NOTIFICATION',
        API_USERNAME: 'API_USERNAME',
        API_PASSWORD: 'API_PASSWORD',
        DEFAULT_LANGUAGE: 'DEFAULT_LANGUAGE',
        ISOLATED_USERS: 'ISOLATED_USERS',
        CUSTOM_TRANSLATIONS: 'CUSTOM_TRANSLATIONS',
        PATIENT_CATEGORY: 'PATIENT_CATEGORY',
        PATIENT_CATEGORIES: 'PATIENT_CATEGORIES',
        CHOOSE_LAB_EXCEPTIONS: 'CHOOSE_LAB_EXCEPTIONS',
        CLASP_MATERIAL: 'CLASP_MATERIAL',
        ORTHODONTICS_COLORS: 'ORTHODONTICS_COLORS',
        FACIAL_LOOP: 'FACIAL_LOOP',
        CLASP_TYPES: 'CLASP_TYPES',
        SPRING_TYPES: 'SPRING_TYPES',
        METAL_DESIGN: 'METAL_DESIGN',
        TESTING_STEPS: 'TESTING_STEPS',
        PONTIC_DESIGN: 'PONTIC_DESIGN',
        OCCLUSION_TYPE: 'OCCLUSION_TYPE',
        CONTACT_TYPE: 'CONTACT_TYPE',
        INVOICING_MODULE: 'INVOICING_MODULE',
        ORDER_PREFILL: 'ORDER_PREFILL',
        ORDER_PREFILL_CLINIC_EXT_ID: 'ORDER_PREFILL_CLINIC_EXT_ID',
        RATING_REMARKS: 'RATING_REMARKS',
        APPROVED_STATUS: 'APPROVED_STATUS',
        IMPLANT_STEPS: 'IMPLANT_STEPS',
        DENTURE_STEPS: 'DENTURE_STEPS',
        EXPORT_PRODUCTION: 'EXPORT_PRODUCTION',
        REASON_FOR_EXCEPTION: 'REASON_FOR_EXCEPTION',
        RATING_COLUMN: 'RATING_COLUMN',
        PARTIAL_DENTURE_STEPS: 'PARTIAL_DENTURE_STEPS',
        SAMPLE_METHOD: 'SAMPLE_METHOD',
        SAMPLE_CONTENT: 'SAMPLE_CONTENT',
        AUTO_APPROVE: 'AUTO_APPROVE',
        MANDATORY_COMMENTS: 'MANDATORY_COMMENTS',
        WHITE_LABEL: 'WHITE_LABEL',
        EXTERNAL_LAB_USERS: 'EXTERNAL_LAB_USERS',
        LAB_WORKFLOW: 'LAB_WORKFLOW',
        INVOICING_TYPE: 'INVOICING_TYPE',
        INVOICING_DELIVERY: 'INVOICING_DELIVERY',
        MERGE_INVOICE_AND_DELIVERY_NOTES: 'MERGE_INVOICE_AND_DELIVERY_NOTES',
        CERTIFICATION: 'CERTIFICATION',
        CERTIFICATION_REPORT: 'CERTIFICATION_REPORT',
        FORTNOX: 'FORTNOX',
        VISMA: 'VISMA',
        PTJ_ORGANIZATION: 'PTJ_ORGANIZATION',
        PTJ_SETTINGS: 'PTJ_SETTINGS',
        PRIVATE_ELASTIC_DASHBOARD: 'PRIVATE_ELASTIC_DASHBOARD',
        SCAN_CASES: 'SCAN_CASES',
        THREE_SHAPE_INTEGRATION: 'THREE_SHAPE_INTEGRATION',
        THREE_SHAPE_CLIENT_ID: 'THREE_SHAPE_CLIENT_ID',
        THREE_SHAPE_DCM_FILE_DOWNLOAD: 'THREE_SHAPE_DCM_FILE_DOWNLOAD',
        THREE_SHAPE_PLY_FILE_DOWNLOAD: 'THREE_SHAPE_PLY_FILE_DOWNLOAD',
        CHAT_TEMPLATE: 'CHAT_TEMPLATE',
        LAB_MILLING: 'LAB_MILLING',
        EDIT_USER_TITLE: 'EDIT_USER_TITLE',
        TRANSPORT_PROVIDERS: 'TRANSPORT_PROVIDERS',
        SHOW_ORDER_CREATOR_IN_PER_ORDER_INVOICE: 'SHOW_ORDER_CREATOR_IN_PER_ORDER_INVOICE',
        MEDIT_INTEGRATION: 'MEDIT_INTEGRATION',
        DEXIS_INTEGRATION: 'DEXIS_INTEGRATION',
        PANDA_INTEGRATION: 'PANDA_INTEGRATION',
        PANDA_INTEGRATION_EU: 'PANDA_INTEGRATION_EU',
        ORDER_FORM_AI: 'ORDER_FORM_AI',
        ALLOW_LAB_INVOICE_OVERRIDE: 'ALLOW_LAB_INVOICE_OVERRIDE',
        SALESFORCE_INTEGRATION: 'SALESFORCE_INTEGRATION',
        DS_CORE_INTEGRATION: 'DS_CORE_INTEGRATION',
        HIDE_OTHER_CLINICS_ORDERS_FOR_DENTIST_USER: 'HIDE_OTHER_CLINICS_ORDERS_FOR_DENTIST_USER',
        PRODUCTION_PLANNING: 'PRODUCTION_PLANNING',
        PRODUCTION_VALUE_REPORT: 'PRODUCTION_VALUE_REPORT',
        PASSWORD_MAX_AGE_DAYS: 'PASSWORD_MAX_AGE_DAYS',
        AUTO_INCREMENT_LOCAL_DENTIST_ID: 'AUTO_INCREMENT_LOCAL_DENTIST_ID',
        HISTORICAL_ORDERS: 'HISTORICAL_ORDERS',
    },
    PROPERTY: {
        MATERIAL: 'MATERIAL',
        CLASP_MATERIAL: 'CLASP_MATERIAL',
        ORTHODONTICS_COLORS: 'ORTHODONTICS_COLORS',
        FACIAL_LOOP: 'FACIAL_LOOP',
        CLASP_TYPES: 'CLASP_TYPES',
        SPRING_TYPES: 'SPRING_TYPES',
        METAL_DESIGN: 'METAL_DESIGN',
        TESTING_STEPS: 'TESTING_STEPS',
        IMPLANT_STEPS: 'IMPLANT_STEPS',
        DENTURE_STEPS: 'DENTURE_STEPS',
        PONTIC_DESIGN: 'PONTIC_DESIGN',
        OCCLUSION_TYPE: 'OCCLUSION_TYPE',
        CONTACT_TYPE: 'CONTACT_TYPE',
        RETAINMENT: 'RETAINMENT',
        CLASP_TEETH: 'CLASP_TEETH',
        SPRING_TEETH: 'SPRING_TEETH',
        EXPANSION_SCREW: 'EXPANSION_SCREW',
        PROTRUSION: 'PROTRUSION',
    },
    WARRANTY_TYPES: ['NOT_CEMENTED', 'CEMENTED', 'UNKNOWN'],
    // TODO: How to translate
    MATERIALS: ['Lithium Disilicate', 'Empress', 'Zirkonia', 'Gold', 'PFM-Gold', 'PFM-Titan', 'PFM-Cocr'],
    SHADES: [
        {
            name: 'Bioform',
            colors: [
                '51',
                '52',
                '53',
                '54',
                '55',
                '56',
                '59',
                '62',
                '63',
                '64',
                '65',
                '66',
                '67',
                '68',
                '69',
                '70',
                '77',
                '81',
                '82',
                '83',
                '84',
                '85',
                '91',
                '92',
                '93',
                '94',
                '95',
                '96',
            ],
        },
        {
            name: 'Vita Classic',
            colors: [
                'A1',
                'A2',
                'A3',
                'A3.5',
                'A4',
                'B1',
                'B2',
                'B3',
                'B4',
                'C1',
                'C2',
                'C3',
                'C4',
                'D2',
                'D3',
                'D4',
                '0M1',
                '0M2',
                '0M3',
            ],
        },
        {
            name: 'Vita 3D Master',
            colors: [
                '1M1',
                '1M2',
                '2L1.5',
                '2L2.5',
                '2M1',
                '2M2',
                '2M3',
                '2R1.5',
                '2R2.5',
                '3L1.5',
                '3L2.5',
                '3M1',
                '3M2',
                '3M3',
                '3R1.5',
                '3R2.5',
                '4L1.5',
                '4L2.5',
                '4M1',
                '4M2',
                '4M3',
                '4R1.5',
                '4R2.5',
                '5M1',
                '5M2',
                '5M3',
            ],
        },
        {
            name: 'Chromascope',
            colors: [
                '110',
                '120',
                '130',
                '140',
                '210',
                '220',
                '230',
                '240',
                '310',
                '320',
                '330',
                '340',
                '410',
                '420',
                '430',
                '440',
                '510',
                '520',
                '530',
                '540',
            ],
        },
        {
            name: 'Myersons',
            colors: ['C', 'D', 'E', 'F', 'G', 'H', 'I', '41', '58', '60', '62', '65', '69', '70', '71', '73', '74'],
        },
        {
            name: 'Verident',
            colors: [
                'B1',
                'P1',
                'P2',
                'P3',
                'P4',
                'P5',
                'P6',
                'R1',
                'R2',
                'R3',
                'R4',
                'R5',
                'Y1',
                'Y2',
                'Y3',
                'Y4',
                'Y5',
                'Y6',
            ],
        },
        {
            name: 'SR Vivodent',
            colors: [
                'O1',
                '1A',
                '1C',
                '1D',
                '1E',
                '2A',
                '2B',
                '2C',
                '2E',
                '3A',
                '3C',
                '3E',
                '4A',
                '4B',
                '4C',
                '4D',
                '5B',
                '6B',
                '6C',
                '6D',
                '01',
            ],
        },
        {
            name: 'Kulzer Delara',
            colors: [
                'A1',
                'A2',
                'A3',
                'A3.5',
                'A4',
                'B1',
                'B2',
                'B3',
                'B4',
                'C1',
                'C2',
                'C3',
                'C4',
                'D2',
                'D3',
                'D4',
                'BL2',
                'BL3',
            ],
        },
        {
            name: 'Ivoclar',
            colors: [
                'A1',
                'A2',
                'A3',
                'A3.5',
                'A4',
                'B1',
                'B2',
                'B3',
                'B4',
                'C1',
                'C2',
                'C3',
                'C4',
                'D2',
                'D3',
                'D4',
                'BL1',
                'BL2',
                'BL3',
                'BL4',
            ],
        },
    ],
    FACIAL_LOOP: ['FACIAL_LOOP', 'BASS_SPRING'],
    CLASP_TYPES: ['ADAM', 'BALL', 'ARROW'],
    CONTACT_TYPE: ['HARD', 'NORMAL', 'LIGHT'],
    CLASP_MATERIAL: ['GOLD', 'STEEL'],
    OCCLUSION_TYPE: ['HARD', 'NORMAL', 'LIGHT', 'NONE'],
    SPRING_TYPES: ['Z_SPRING', 'EXPANSION_SCREW', 'TELESCOPE_SCREW'],
    ORTHODONTICS_COLORS: ['Red', 'Blue', 'Green', 'Orange', 'Yellow', 'Purple', 'Pink', 'Transparent'],
    RETAINMENT: ['Screwed', 'Cemented'],
    TESTING_STEPS: ['TESTING', 'COMPLETE'],
    IMPLANT_STEPS: [
        'INDIVIDUAL_TRAY',
        'BITE_BLOCK',
        'DENTITION',
        'DENTITION_WITH_SKELETON',
        'SKELETON_TESTING',
        'COMPLETE',
    ],
    DENTURE_STEPS: ['IMMEDIATE', 'INDIVIDUAL_TRAY', 'BITE_BLOCK', 'DENTITION', 'COMPLETE'],
    METAL_DESIGN: [
        {
            name: 'NO_METAL_MARGIN',
            imageUrl: '/images/no-Metal.png',
        },
        {
            name: 'PORCELAIN_MARGIN',
            imageUrl: '/images/Porcelain-Margin.png',
        },
        {
            name: 'SMALL_METAL_MARGIN',
            imageUrl: '/images/Small-metal.png',
        },
        {
            name: 'LINGUAL_METAL_MARGIN',
            imageUrl: '/images/Lingual-Metal.png',
        },
    ],
    PONTIC_DESIGN: [
        {
            name: 'SANITARY',
            imageUrl: '/images/Sanitary.png',
        },
        {
            name: 'BULLET',
            imageUrl: '/images/Bullet.png',
        },
        {
            name: 'MOD_RIDGE_LAP',
            imageUrl: '/images/Mod-ridge-lap.png',
        },
        {
            name: 'FULL_RIDGE_LAP',
            imageUrl: '/images/Full-Ridge-Lap.png',
        },
        {
            name: 'OVATE',
            imageUrl: '/images/Ovate.png',
        },
    ],

    // Clasp/spring tooth options in dental-chart order: upper right to upper left, then lower right to lower left.
    CLASP_TEETH: [
        '18',
        '17',
        '16',
        '15',
        '14',
        '13',
        '12',
        '11',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '48',
        '47',
        '46',
        '45',
        '44',
        '43',
        '42',
        '41',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
    ].map((tooth) => ({ id: Number(tooth) })),
    ORDER_STATUSES: [
        {
            name: 'SENT_BY_CUSTOMER',
            value: 'sent_by_customer',
        },
        {
            name: 'ACCEPTED_BY_LAB',
            value: 'accepted_by_lab',
        },
        {
            name: 'SENT_BY_LAB',
            value: 'sent_by_lab',
        },
        {
            name: 'ORDER_APPROVED',
            value: 'order_approved',
        },
        {
            name: 'CANCELLED',
            value: 'cancelled',
        },
        {
            name: 'REJECTED',
            value: 'declined',
        },
    ],
    TRANSPORT_TIME: {
        time: '14',
        PICKUP: 11, //11 am
        DELIVERY: 18, // 5:30 pm
    },
    HOLIDAYS: [
        new Date('2023-01-01').setHours(0, 0, 0, 0),
        new Date('2023-01-06').setHours(0, 0, 0, 0),
        new Date('2023-04-07').setHours(0, 0, 0, 0),
        new Date('2023-04-09').setHours(0, 0, 0, 0),
        new Date('2023-04-10').setHours(0, 0, 0, 0),
        new Date('2023-05-01').setHours(0, 0, 0, 0),
        new Date('2023-05-18').setHours(0, 0, 0, 0),
        new Date('2023-05-28').setHours(0, 0, 0, 0),
        new Date('2023-06-06').setHours(0, 0, 0, 0),
        new Date('2023-06-24').setHours(0, 0, 0, 0),
        new Date('2023-11-04').setHours(0, 0, 0, 0),
        new Date('2023-12-25').setHours(0, 0, 0, 0),
        new Date('2023-12-26').setHours(0, 0, 0, 0),

        new Date('2024-01-01').setHours(0, 0, 0, 0),
        new Date('2024-01-06').setHours(0, 0, 0, 0),
        new Date('2024-03-29').setHours(0, 0, 0, 0),
        new Date('2024-03-31').setHours(0, 0, 0, 0),
        new Date('2024-04-01').setHours(0, 0, 0, 0),
        new Date('2024-05-01').setHours(0, 0, 0, 0),
        new Date('2024-05-09').setHours(0, 0, 0, 0),
        new Date('2024-05-19').setHours(0, 0, 0, 0),
        new Date('2024-06-06').setHours(0, 0, 0, 0),
        new Date('2024-06-22').setHours(0, 0, 0, 0),
        new Date('2024-11-02').setHours(0, 0, 0, 0),
        new Date('2024-12-25').setHours(0, 0, 0, 0),
        new Date('2024-12-26').setHours(0, 0, 0, 0),

        new Date('2025-01-01').setHours(0, 0, 0, 0),
    ],
    HOURS: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
    ],
    MINUTES: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
    TRANSPORT_DEADLINES: [
        'No Deadline',
        '8:00',
        '8:30',
        '9:00',
        '9:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
    ],
    COOKIE_OPTIONS: {
        path: '/',
        sameSite: 'strict' as const,
        domain:
            process.env.REACT_APP_DEPLOY_ENV === 'production' || process.env.REACT_APP_DEPLOY_ENV === 'staging'
                ? '.denthub.com'
                : 'localhost',
        secure: true,
    },
    TAG_COLORS: [
        '#c9372c',
        '#0c66e4',
        '#5b7f24',
        '#ae4787',
        '#b19844',
        '#222222',
        '#da92b1',
        '#ca6a00',
        '#008080',
        '#00CED1',
        '#191970',
        '#696969',
        '#ff0000',
    ],
    COPY_TYPES: ['RELATED_ORDER', 'UNRELATED_ORDER'],
    ADMIN_AUTH_METHODS: ['PASSWORD', 'SITHS'],
    RELEASE_NOTE_COOKIE_NAME_PREFIX: 'lastRelaseNoteVersionRead_',
    TEMPLATE_NAME: [
        {
            key: 'ACTION_BASED_CLIENT_ACTION_PRICE_LIST',
            value: 'action-based-client-action-price-list',
        },
        {
            key: 'ACTION_PRICE_LIST',
            value: 'action-price-list',
        },
        {
            key: 'CERTIFICATION',
            value: 'certification',
        },
        {
            key: 'CLIENT_LIST',
            value: 'client-list',
        },
        {
            key: 'COLLECTIVE_INVOICES',
            value: 'collective-invoices',
        },
        {
            key: 'CREDIT_INVOICES',
            value: 'credit-invoices',
        },
        {
            key: 'DEADLINE_SCHEDULE',
            value: 'deadline-schedule',
        },
        {
            key: 'DELIVERY_NOTES',
            value: 'delivery-notes',
        },
        {
            key: 'DESTINATION_ADDRESS_LABEL',
            value: 'destination-address-label',
        },
        {
            key: 'DEVIATION_REPORT',
            value: 'deviation-report',
        },
        {
            key: 'INVOICE_SPECIFICATION',
            value: 'invoice-specification',
        },
        {
            key: 'MATERIAL_LIST',
            value: 'material-list',
        },
        {
            key: 'MATERIAL_PRICE_LIST',
            value: 'material-price-list',
        },
        {
            key: 'ORDER_FORM',
            value: 'order-form',
        },
        {
            key: 'ORDER_RECEIPT',
            value: 'order-receipt',
        },
        {
            key: 'ORDER_SUMMARY',
            value: 'order-summary',
        },
        {
            key: 'PATIENT_LABEL',
            value: 'patient-label',
        },
        {
            key: 'PATIENT_SPECIFICATION',
            value: 'patient-specification',
        },
        {
            key: 'SINGLE_INVOICES',
            value: 'single-invoices',
        },
        {
            key: 'TRANSPORT_INVOICE_SPECIFICATION',
            value: 'transport-invoice-specification',
        },
        {
            key: 'TRANSPORT_SCHEDULE',
            value: 'transport-schedule',
        },
        {
            key: 'WORK_SHEET',
            value: 'work-sheet-v2',
        },
        {
            key: 'WORK_SHEET_SUBCONTRACTOR',
            value: 'work-sheet-subcontractor',
        },
    ],
};
